import { connect } from 'react-redux';

import { saveFilters, clearFilters } from 'features/pagination/actions/paginationActions';
import { getPaginationFilters } from 'features/pagination/selectors/paginationSelectors';
import {
    setDateRangeContractDashboard,
    setDateRangeContractPrioritiesDashboard,
} from 'features/contract/actions/contractActions';
import { setDateRangeBenefitTemplateDashboard } from 'features/benefit/actions/benefitTemplateActions';
import { setDateRangeBenefitPriorityDashboard } from 'features/benefit/actions/benefitActions';
import { AppState } from 'common/appState';

import { DashboardFilter } from '../components/DashboardFilter';

interface OwnProps {
    filterId: number;
    backUrl: string;
    onClose: () => void;
    // Refetches the table so applying or resetting filters updates the current page.
    onApply?: () => void;
}

const mapStateToProps = (state: AppState, ownProps: OwnProps) => ({
    filterId: ownProps.filterId,
    backUrl: ownProps.backUrl,
    formInitial: getPaginationFilters(state).find(
        (filter) => filter.paginatedView === ownProps.filterId,
    ),
});

const applyAndClose = (ownProps: OwnProps) => {
    ownProps.onClose();

    if (ownProps.onApply) {
        // Matches FilterDrawerContracts/FilterDrawerBenefits: let the drawer close first.
        setTimeout(() => ownProps.onApply!(), 50);
    }
};

const mapDispatchToProps = (dispatch: any, ownProps: OwnProps) => ({
    saveFilters: (payload: Parameters<typeof saveFilters>[0]) => {
        dispatch(saveFilters(payload));
        applyAndClose(ownProps);
    },
    clearFilters: (view: Parameters<typeof clearFilters>[0]) => {
        dispatch(clearFilters(view));
        applyAndClose(ownProps);
    },
    setDateRangeContractDashboard: (range: Parameters<typeof setDateRangeContractDashboard>[0]) =>
        dispatch(setDateRangeContractDashboard(range)),
    setDateRangeContractPrioritiesDashboard: (
        range: Parameters<typeof setDateRangeContractPrioritiesDashboard>[0],
    ) => dispatch(setDateRangeContractPrioritiesDashboard(range)),
    setDateRangeBenefitTemplateDashboard: (
        range: Parameters<typeof setDateRangeBenefitTemplateDashboard>[0],
    ) => dispatch(setDateRangeBenefitTemplateDashboard(range)),
    setDateRangeBenefitPriorityDashboard: (
        range: Parameters<typeof setDateRangeBenefitPriorityDashboard>[0],
    ) => dispatch(setDateRangeBenefitPriorityDashboard(range)),
});

export const DashboardFilterDrawerContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DashboardFilter as any);
